import React, { useState } from 'react';
import { message, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { formValidation } from '../../utils/FormValidation';
import { useDispatch, useSelector } from 'react-redux';
import { forgotUserPassword } from '../../redux/features/auth/authActions';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error } = useSelector((state) => state.auth);

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        console.log(email);

        try {
            await dispatch(forgotUserPassword({ email })).unwrap(); //send data htmlFor api call
            message.success("Password reset code sent to email")
            navigate("/Reset-password"); //navitage to password reset page
        } catch (err) {
            const errorMessage = err.error || 'Reset code send failed';
            message.error(errorMessage);
        }

    };

    return (
        <section className="bg-background-primary-color">
            <Spin spinning={loading} fullscreen />
            <div className="flex flex-col items-center justify-center  px-1 py-8 mx-auto md:h-screen lg:py-0">
                <a className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
                    <img src="/img/logo.png" className='w-[220px]' alt="Logo" />
                </a>
                <div className="w-full bg-gray-800 rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 ">
                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                        <h1 className="text-xl font-poppins font-bold leading-tight tracking-tight  md:text-2xl text-gray-200">
                            Forgot Password
                        </h1>
                        <form onSubmit={handleForgotPassword} className="space-y-4 md:space-y-6">
                            <div>
                                <label onBlur={() => {
                                    // Basic validation htmlFor email format
                                    if (!/\S+@\S+\.\S+/.test(email)) {
                                        message.error('Please enter a valid email address.');
                                    }
                                }} htmlFor="email" className="block mb-2 font-poppins text-sm font-medium text-gray-200">Your email</label>
                                <input type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="name@example.com" required />
                            </div>


                            {/* Btn */}
                            <p className="text-sm text-gray-400">
                                We will send a verification code to this email to help you reset your password.
                            </p>
                            <button type="submit" className="w-full bg-btn-color transition-all duration-300 hover:bg-btn-hover-color focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center text-gray-900">Send Code</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ForgotPassword;
